export default __webpack_public_path__ + "static/media/phone.c8ea0918.svg";